<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import { getParamJson } from "@/utils/index";
import { setToken } from "@/utils/auth";
import { getInfo } from "@/api/home";

export default {
  name: 'App',
  // components: {
  //   HelloWorld
  // }
  created() {
    let tmp = getParamJson()
    if(tmp.token){
      setToken(tmp.token)
      if(tmp.redirect) {
        getInfo().then(r=>{
          window.sessionStorage.setItem('user', JSON.stringify(r.user))
          switch (tmp.redirect) {
            case "/userCar/procedure":
              this.$router.push(tmp.id ? './vehicleApplyDetail?page=approval&acpplyId='+tmp.id : './vehicleApproval')
              break;
            case "/vehicleApply":
              this.$router.push(tmp.id ? './vehicleApplyDetail?acpplyId='+tmp.id : './vehicleApply')
              break;
            case '/userCar/trip':
              this.$router.push(tmp.id ? './orderTakeDetail?id='+tmp.id : './orderTake')
              break;
          }
        })
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.van-cell{
  min-height: 60px;
  padding: 0 16px!important;
  align-items: center;
}
.self-search .van-cell{
  min-height: 24px;
  padding: 5px 8px 5px 0!important;
}
</style>
